import React from 'react';

import Portal from './Portal';
import ModalShell from './ModalShell';

type Props = {
  render: () => React.Element,
  trigger: ?React.Element,
  isOpened: ?boolean,
  onClose: () => void,
}

function Modal({render, trigger, isOpened, onClose}: Props) {
  return (
    <Portal closeOnEsc openByClickOn={trigger} isOpened={isOpened} onClose={onClose} render={() => (
      <ModalShell>{render()}</ModalShell>
    )} />
  );
}

export default Modal;



// WEBPACK FOOTER //
// ../src/client/components/modal/Modal.js